module.exports = __webpack_public_path__ + "8a36205bd9b83e03af0591a004bc97f4.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roboto/Roboto-Regular.ttf
// module id = 372
// module chunks = 0